export const RECEIVE_DASHBOARD_DATA = 'RECEIVE_DASHBOARD_DATA';
